export default "__VITE_ASSET__9rY_lL6u__"